<mat-card class="slidecontent">
    <div class="headcontent">
      <div class="pophead">
        <h3>Create New</h3>
    
        <mat-icon class="close" (click)="closeListing(close)">close</mat-icon>
      </div>
    </div>
    
      <div class="dialog_content">
        


       
          <div class="usernameinfo bnone" fxLayout="row" fxlayoutAlign="center" >
            <div class="picname">
                <div class="pic">
                    <!-- <img src="../../../../../assets/images/avatars/andrew.jpg" alt=""> -->
                </div>
                <div class="name">
                  <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput placeholder="Name" value="">
                  </mat-form-field>   
                </div>
            </div>
               
               
            </div>
    
            <form class="">
                <mat-form-field>
                  <mat-label>Type</mat-label>
                  <input matInput placeholder="Name" value="">
                </mat-form-field>   
               
                  <mat-form-field>
                    <mat-label>Title</mat-label>
                    <input matInput placeholder="Title" value="">
                  </mat-form-field>

                  <mat-form-field>
                    <mat-label>Email Domain</mat-label>
                    <input matInput placeholder="Name" value="">
                  </mat-form-field> 
                  <mat-form-field>
                    <mat-label>Owner</mat-label>
                    <input matInput placeholder="Name" value="">
                  </mat-form-field>  

                  <mat-form-field>
                    <mat-label>Type</mat-label>
                    <mat-select value="">
                      <mat-option value="">Signashare</mat-option>
                      <mat-option value="">Realty APX</mat-option>
                    </mat-select>
                  </mat-form-field>
                  
                  <mat-form-field>
                    <mat-label>Contact type</mat-label>
                    <mat-select value="">
                      <mat-option value="">Potential Customer</mat-option>
                      
                    </mat-select>
                  </mat-form-field>  
               
                       
              </form>
      

      </div>
    
    
    <div class="actionBtn">

      <button mat-flat-button class="cancel" (click)="closeListing(close)" >Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit"  color="primary">Create</button>
      </div>
</mat-card >
  
  <div class="overlay" (click)="closeListing(close)"></div>
  